import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'modalMap' })
export class ModalMapPipe implements PipeTransform {

  transform(value: any, args: any): any {
    let data = value;
    if (value && value.length > 0) {
      Object.keys(args).forEach(key => {
        if (args[key]) {
          data = data.filter(item => {
            if (item[key] === undefined || item[key] === '') {
            }else if (item[key].includes(args[key])) {
              return true;
            }
          });
          // value = data;
        }
      });
    }
    return data || value;
  }

}
